import { render, staticRenderFns } from "./PensionByAgeInputs.vue?vue&type=template&id=6a50fc4d&scoped=true&"
import script from "./PensionByAgeInputs.vue?vue&type=script&lang=js&"
export * from "./PensionByAgeInputs.vue?vue&type=script&lang=js&"
import style0 from "./PensionByAgeInputs.vue?vue&type=style&index=0&id=6a50fc4d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a50fc4d",
  null
  
)

export default component.exports